import { defineMessages } from 'react-intl'

const scope = `procurify.vendor.page`

export default defineMessages({
  vendorManagementPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Vendor management',
  },
})
